import React from 'react';

import Modal from 'react-bootstrap/Modal';

import './ModalDialog.css';
import { CLOCK_EMOJI_HOUR_LIST, CLOCK_EMOJI_THIRTY_LIST } from '../constants';
import { IEvent } from '../interfaces';
import { EventCategory } from '../enums';

// Remove emojis from ALL workshop subtitles
const removeEmojisFromSubtitle = (subtitle: string, event: IEvent): string => {
	if (!subtitle) return subtitle;
	
	// Check if event is a workshop
	const isWorkshop = event.category === EventCategory.Workshop1 ||
		event.category === EventCategory.Workshop2 ||
		event.category === EventCategory.Workshop3 ||
		event.category === EventCategory.Workshop4;
	
	if (isWorkshop) {
		// Remove emojis using regex - covers most emoji ranges
		// Also remove leading/trailing dashes and spaces that might be left
		let cleaned = subtitle.replace(/[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]/gu, '').trim();
		// Clean up any double spaces or dashes
		cleaned = cleaned.replace(/\s+/g, ' ').replace(/^\s*-\s*|\s*-\s*$/g, '').trim();
		return cleaned;
	}
	
	return subtitle;
};

interface PropTypes {
	show: boolean;
	onHide: () => void;
	formattedTime: string;
	event: IEvent;
}

const ModalDialog: React.FC<PropTypes> = props => {
	const hours = props.event.start.getHours();
	const minutes = props.event.start.getMinutes();

	return (
		<Modal show={props.show} onHide={props.onHide} centered className='rounded'>
			<Modal.Header closeButton>
				<Modal.Title>
					{props.event.name} {props.event.subtitle && `- ${removeEmojisFromSubtitle(props.event.subtitle, props.event)}`}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p className="modal-time">
					<span role="img" aria-label="clock emoji">
						{(minutes < 30 ? CLOCK_EMOJI_HOUR_LIST : CLOCK_EMOJI_THIRTY_LIST)[hours % 12]}
					</span>
					&nbsp;
					<span className="time-text">{props.formattedTime}</span>
				</p>
				{props.event.location && (
					<p className="modal-location">
						<span role="img" aria-label="round pushpin emoji">
							📍
						</span>
						&nbsp;
						<span>{props.event.location}</span>
					</p>
				)}
				{props.event.description && <p className="modal-description">{props.event.description}</p>}
			</Modal.Body>
		</Modal>
	);
};

export default ModalDialog;
